(function () {
    'use strict';

    angular.module('app')
        .factory('User', User);

    /* @ngInject */
    function User(ResourceHelper) {
        var urlAdmin = 'api/admin/user';
        return ResourceHelper.getResource('user', {}, {
            'get': {
                method: 'GET',
                url: urlAdmin + '/:id',
                isArray: false
            },
            'findAll': {
                method: 'GET',
                url: urlAdmin + '/findAll'
            },
            'getLoginById': {
                method: 'GET',
                url: urlAdmin + '/getLoginById/:id'
            }
        });
    }
})();
